module.exports = __webpack_public_path__ + "img/logo.81e7c669.png";